export default __webpack_public_path__ + "static/media/uploadInvoiceWhite.6e4c5bac.svg";